export interface NavItem {
  path: string;
  label: string;
  icon: string; // emoji-style icon, keeps the app dependency-free
  description: string;
  chapter: string;
}

export const NAV_ITEMS: NavItem[] = [
  {
    path: 'introduction',
    label: 'introduction',
    icon: 'menu_book',
    description: 'nav_desc_introduction',
    chapter: 'nav_chapter_1',
  },
  {
    path: 'getting-started',
    label: 'getting_started',
    icon: 'rocket_launch',
    description: 'nav_desc_getting_started',
    chapter: 'nav_chapter_2',
  },
  {
    path: 'discover',
    label: 'discover',
    icon: 'explore',
    description: 'nav_desc_discover',
    chapter: 'nav_chapter_3',
  },
  {
    path: 'dashboard',
    label: 'dashboard',
    icon: 'dashboard',
    description: 'nav_desc_dashboard',
    chapter: 'nav_chapter_4',
  },
  {
    path: 'profile',
    label: 'profile',
    icon: 'person',
    description: 'nav_desc_profile',
    chapter: 'nav_chapter_4',
  },
  {
    path: 'security',
    label: 'security',
    icon: 'lock',
    description: 'nav_desc_security',
    chapter: 'nav_chapter_4',
  },
  {
    path: 'applications',
    label: 'applications',
    icon: 'description',
    description: 'nav_desc_applications',
    chapter: 'nav_chapter_4',
  },
  {
    path: 'trainings',
    label: 'trainings',
    icon: 'school',
    description: 'nav_desc_trainings',
    chapter: 'nav_chapter_4',
  },
  {
    path: 'favorites',
    label: 'favorites',
    icon: 'star',
    description: 'nav_desc_favorites',
    chapter: 'nav_chapter_4',
  },
  {
    path: 'network',
    label: 'network',
    icon: 'hub',
    description: 'nav_desc_network',
    chapter: 'nav_chapter_4',
  },
  {
    path: 'glossary',
    label: 'glossary',
    icon: 'menu_book',
    description: 'nav_desc_glossary',
    chapter: 'nav_chapter_5',
  },
  {
    path: 'support',
    label: 'support',
    icon: 'help',
    description: 'nav_desc_support',
    chapter: 'nav_chapter_6',
  },
];
